import { demoProfiles } from '~/content/dating-demo'

export const DEMO_ROUND_SIZE = 5

export function createDemoRound ({ age, seeking }, random = Math.random) {
  const numericAge = Number(age)
  if (!Number.isInteger(numericAge) || numericAge < 18 || numericAge > 99 || !['woman', 'man', 'everyone'].includes(seeking)) return []
  // Sample from nearby ages, without implying an exact age filter or location match.
  const candidates = demoProfiles.filter(profile => seeking === 'everyone' || profile.gender === seeking)
    .sort((a, b) => Math.abs(a.age - numericAge) - Math.abs(b.age - numericAge))
    .slice(0, 10)
  for (let i = candidates.length - 1; i > 0; i--) {
    const j = Math.floor(random() * (i + 1))
    ;[candidates[i], candidates[j]] = [candidates[j], candidates[i]]
  }
  return candidates.slice(0, DEMO_ROUND_SIZE)
}
